/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rapporten_Config_Elements_Rapport_NotitieInputs */

const nl_rapporten_config_elements_rapport_notitie = /** @type {(inputs: Rapporten_Config_Elements_Rapport_NotitieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rapport notitie`)
};

/**

* @param {Rapporten_Config_Elements_Rapport_NotitieInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const rapporten_config_elements_rapport_notitie = /** @type {((inputs?: Rapporten_Config_Elements_Rapport_NotitieInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rapporten_Config_Elements_Rapport_NotitieInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_rapporten_config_elements_rapport_notitie(inputs)
});
export { rapporten_config_elements_rapport_notitie as "rapporten.config.elements.rapport_notitie" }